class RealProductConfidence extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.rotateFallbackImage();

    const supportLink = this.querySelector('[data-real-pro-trigger]');
    supportLink?.addEventListener('click', (event) => this.handleSupportClick(event, supportLink));
  }

  rotateFallbackImage() {
    const media = this.querySelector('[data-pro-media][data-rotate="true"]');
    const image = media?.querySelector('img');
    const images = media?.dataset.fallbackImages?.split('|').filter(Boolean) ?? [];

    if (!image || images.length < 2) return;

    image.src = images[Math.floor(Math.random() * images.length)];
  }

  handleSupportClick(event, supportLink) {
    if (!window.LiveChatWidget?.call) return;

    event.preventDefault();

    let visibility = null;

    try {
      visibility = window.LiveChatWidget.get?.('state')?.visibility ?? null;
    } catch (_error) {
      visibility = null;
    }

    const isOpen =
      visibility === 'maximized' || (!visibility && supportLink.dataset.livechatOpen === 'true');

    window.LiveChatWidget.call(isOpen ? 'minimize' : 'maximize');
    supportLink.dataset.livechatOpen = isOpen ? 'false' : 'true';

    if (!isOpen) {
      window.setTimeout(() => {
        document.querySelector('#chat-widget-container iframe')?.focus();
      }, 100);
    }
  }
}

if (!customElements.get('real-product-confidence')) {
  customElements.define('real-product-confidence', RealProductConfidence);
}
